module.exports = __webpack_public_path__ + "static/img/mypage-menu-icon04.1366a628.svg";